import './UnfundedAccountCard.scss';

import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';

import BaseCard from 'components/shared/Card/BaseCard';
import { transactions } from 'services/Externals';
import { hasAlaska529Only } from 'state/view/ViewSelectors';

import { ReactComponent as Bell } from 'assets/icons/bell.svg';
import { getHasUnfundedMFAccount } from 'state/account/AccountSelectors';
import { addQueryStringParam } from '../../../support/BrowserUtils';

const UnfundedAccountCard = ({ hasUnfundedAccount, hasAlaska529Only }) => {
  if (!hasUnfundedAccount) {
    return null;
  }

  return (
    <BaseCard
      title={null}
      isLoading={null}
      footer={null}
      className="standard unfunded-account-card-container">
      <div className="top">
        <Bell className="bell-icon" />
        <h3 className="title">Your new account is ready for funding</h3>
      </div>
      <div className="bottom">
        <p>Buy shares or exchange existing assets to fund your account.</p>
        <a
          href={`${addQueryStringParam(
            transactions.mutualFund.buy,
            'nasuAddedFund',
            'true'
          )}`}
          target="_self"
          rel="noopener noreferrer"
          className={classnames('action no-underline', {
            alaska: hasAlaska529Only
          })}>
          Buy Shares
        </a>
      </div>
    </BaseCard>
  );
};

const mapStateToProps = (state) => ({
  hasUnfundedAccount: getHasUnfundedMFAccount(state),
  hasAlaska529Only: hasAlaska529Only(state)
});

export default connect(mapStateToProps)(UnfundedAccountCard);
